export const DASHBOARD_CHART_COLORS = [
  "#00c2a3",
  "#90b2b7",
  "#f28b82",
  "#4285f4",
  "#fbbc04",
  "#34a853",
  "#a142f4",
];
